export enum ScatterChartColorLogic {
  ASSET_CLASS = 'colorAssetClass',
  TYPE = 'colorType',
  FACTOR = 'colorFactor',
  INVESTMENT_FOCUS = 'colorInvestmentFocus',
  FUND_CATEGORY = 'colorFundCategory',
}

export const DEFAULT_RISK_RETURN_COLOR_LOGIC =
  (import.meta.env.VITE_DATA_UNIVERSE_COLOR_LOGIC as ScatterChartColorLogic) ?? ScatterChartColorLogic.TYPE;
